<template>
  <div v-if="fila == field && direcction == 'asc' ">
    <CButton @click="onClick(field,'asc' ,order)" class="button" variant="ghost" size="sm"><img src="../assets/icons/up-black.jpg" class="imagen" ></CButton>
    <CButton @click="onClick(field,'desc' ,order)" class="button" variant="ghost" size="sm"><img src="../assets/icons/down-white.jpg" class="imagen" ></CButton>
  </div>
  <div v-else-if="fila == field && direcction == 'desc' ">
    <CButton @click="onClick(field,'asc' ,order)" class="button" variant="ghost" size="sm"><img src="../assets/icons/up-white.jpg" class="imagen" ></CButton>
    <CButton @click="onClick(field,'desc' ,order)" class="button" variant="ghost" size="sm"><img src="../assets/icons/down-black.jpg" class="imagen" ></CButton>
  </div>
  <div v-else>
    <CButton @click="onClick(field,'asc' ,order)" class="button" variant="ghost" size="sm"><img src="../assets/icons/up-white.jpg" class="imagen" ></CButton>
    <CButton @click="onClick(field,'desc' ,order)" class="button" variant="ghost" size="sm"><img src="../assets/icons/down-white.jpg" class="imagen" ></CButton>
  </div>
</template>

<script>
export default {
  name: 'OrderButtons',
  props: {
    field: String,
    order: Boolean,
    fila: String,
    direcction: String,
    onClick: Function,
  }
}
</script>

<style>
  .button{
    width:15px;
    height:15px;
    margin: 0%;
    padding-left: 0%;
    padding-top: 0%;
    padding-right: 0%;
    padding-bottom: 5px;
    display: block !important;
  }
  .imagen{
    width: 7.5px;
    height: 7.5px;
    align-self: center;
    margin-top: -5px;
  }
</style>